import { render } from "./ExamPlaces.vue?vue&type=template&id=04183e7c"
import script from "./ExamPlaces.vue?vue&type=script&lang=js"
export * from "./ExamPlaces.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__